import {
  Button,
  Card,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { useState, useCallback, useEffect } from "react";
import Breadcrumbs from "../../coreComponents/breadcrumbs";
import CommonCardHeader from "../../coreComponents/CommonCardHeader";
import { useAppSelector } from "../../reduxToolkit/hooks";
import Table from "../table/Table";
import ApiService from "../../services/apiService";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import RightIcon from "../svg/RightIcon";
import LeftIcon from "../svg/LeftButton";
import { format } from "date-fns";
import LoadingComponent from "../lodingComponent";
import { Filter } from "react-feather";
import ChackOnOf from "../mapView/ChackOnOf";
import * as XLSX from "xlsx";
import DownloadExcel from "../downloadExcel/DownloadExcel";
import DownloadFileIcon from "../svg/DownloadFile";
import ExportExcel from "../reports/ExportExcel";

const OmsList = () => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const role = useAppSelector((state) => state.role.role);
  const navigate = useNavigate();
  const [selectedId, setSelectedId] = useState<any>();

  const [allData, setAllData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState<
    "all" | "online" | "offline"
  >("all");
  const [pageNumber, setPageNumber] = useState(1);
  const pageSize = 10;

  const fetchAllChacks = async () => {
    setLoading(true);
    try {
      const response = await ApiService.axiosApi(`/chack`, {
        method: "GET",

        params: {
          pageNumber: 0,
          pageSize: 0,
        },
      });
      if (response.success) {
        setAllData(response.data.data || []);
      } else {
        console.log(response.message || "unable to fetch chack data");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllChacks();
  }, []);

  // dateTime format karo
  let formattedData = allData.map((time) => {
    const formatDate = format(new Date(time.dateTime), "yyyy-MM-dd HH:mm:ss");
    return {
      ...time,
      dateTime: formatDate,
    };
  });

  // status filter (online/offline)
  if (statusFilter !== "all") {
    formattedData = formattedData.filter((item: any) => {
      const apiTime = new Date(String(item.dateTime).replace(" ", "T"));
      const diffHours =
        (new Date().getTime() - apiTime.getTime()) / (1000 * 60 * 60);
      const isOffline = diffHours > 2;
      return statusFilter === "offline" ? isOffline : !isOffline;
    });
  }

  // search filter
  if (searchQuery) {
    formattedData = formattedData.filter((item: any) =>
      String(item.chackName || "")
        .toLowerCase()
        .includes(searchQuery.toLowerCase()),
    );
  }

  const totalCount = formattedData.length;
  const totalPages = Math.ceil(totalCount / pageSize) || 1;

  // client-side pagination slice
  const startIndex = (pageNumber - 1) * pageSize;
  const updatedData = formattedData.slice(startIndex, startIndex + pageSize);

  const handleNext = useCallback(() => {
    setPageNumber((prev) => Math.min(totalPages, prev + 1));
  }, [totalPages]);

  const handlePrev = useCallback(() => {
    setPageNumber((prev) => Math.max(1, prev - 1));
  }, []);

  const handleDeleteOms = async (id: string) => {
    try {
      const response = await ApiService.axiosApi(`/oms/deleteoms${id}`, {
        method: "DELETE",
      });
      if (response.success) {
        toast.success("OMS deleted sucessfully");
        fetchAllChacks();
      } else {
        console.log(
          response.message || response.status || "unable to delte oms",
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleDownloadExcel = () => {
    const exportData = formattedData.map((item: any) => ({
      "Chak Name": item.chackName,
      "No. On/Of Valves": item.no_Of_ON_OF_Valves,
      "Distrbutary/Zone": item.distributary_Zone,
      "Scheme/Village": item.scheme_Village,
      Duty: item.duty,
      "Updated Time": item.dateTime,
      Pressure: item.pressure,
      FlowRate: item.flowRate,
      "Today Volume": item.todayVolume,
      "On Valves": item.onValves,
      Door1: item.door1,
      Door2: item.door2,
      "Network Status": item.networkStatus,
      "Battery Status": item.battery,
      "Solar Voltage": item.solarVoltage,
      Temprature: item.temprature,
      "Water Meter": item.waterMeter,
      "Roms Auto": item.romsAuto,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    const sheetName =
      statusFilter === "all"
        ? "All"
        : statusFilter === "online"
          ? "Online"
          : "Offline";
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

    const fileName = `OmsList_${sheetName}_${format(new Date(), "yyyyMMdd_HHmmss")}.xlsx`;
    XLSX.writeFile(workbook, fileName);
  };

  return (
    <>
      <Breadcrumbs mainTitle={"OmsList"} parent={"Oms"} />

      <Card>
        <CommonCardHeader title="Oms List" headClass="pb-3" />
        <div className="d-flex justify-content-between align-items-center pb-2">
          <div
            style={{ marginLeft: "10px" }}
            className="align-items-center flex-row d-flex"
          >
            <div>
              <input
                type="text"
                className="search-input"
                placeholder="...search"
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  setPageNumber(1);
                }}
              />
            </div>
          </div>

          <div className="d-flex align-items-center ">
            <div style={{ minWidth: "200px", marginRight:'10px' }}>
              <ChackOnOf
                chackData={allData}
                variant="cards"
                onFilterChange={(filter) => {
                  setStatusFilter(filter);
                  setPageNumber(1);
                }}
              />
            </div>

            <div style={{marginRight:'10px',marginTop: '-22px' }}>
            <ExportExcel
      fileName={
         statusFilter === 'all'
            ? 'Oms_List_All'
            : statusFilter === 'online'
               ? 'Oms_List_Online'
               : 'Oms_List_Offline'
      }
      columnHeaderMap={{
         chackName: 'Chak Name',
         no_Of_ON_OF_Valves: 'No. On/Of Valves',
         distributary_Zone: 'Distrbutary/Zone',
         scheme_Village: 'Scheme/Village',
         duty: 'Duty',
         dateTime: 'Updated Time',
         pressure: 'Pressure',
         flowRate: 'FlowRate',
         todayVolume: 'Today Volume',
         onValves: 'On Valves',
         door1: 'Door1',
         door2: 'Door2',
         networkStatus: 'Network Status',
         battery: 'Battery Status',
         solarVoltage: 'Solar Voltage',
         temprature: 'Temprature',
         waterMeter: 'Water Meter',
         romsAuto: 'Roms Auto',
      }}
      columnOrder={[
         'chackName',
         'dateTime',
         'no_Of_ON_OF_Valves',
         'distributary_Zone',
         'scheme_Village',
         'duty',
         'pressure',
         'flowRate',
         'todayVolume',
         'onValves',
         'door1',
         'door2',
         'networkStatus',
         'battery',
         'solarVoltage',
         'temprature',
         'waterMeter',
         'romsAuto',
      ]}
      getData={async () => formattedData}
      style={{ width: '110px' }}
   />
            </div>
          </div>
        </div>
        {loading ? (
          <LoadingComponent />
        ) : (
          <Table
            isAction={false}
            data={updatedData}
            columns={[
              { header: "Chak Name", accessor: "chackName" },
              { header: "No. On/Of Valves", accessor: "no_Of_ON_OF_Valves" },
              { header: "Distrbutary/Zone", accessor: "distributary_Zone" },
              { header: "Scheme/Village", accessor: "scheme_Village" },
              { header: "Duty", accessor: "duty" },
              { header: "Updated Time", accessor: "dateTime" },
              { header: "Pressure", accessor: "pressure" },
              { header: "FlowRate", accessor: "flowRate" },
              { header: "Today Volume", accessor: "todayVolume" },
              { header: "On Valves", accessor: "onValves" },
              { header: "Door1", accessor: "door1" },
              { header: "Door2", accessor: "door2" },
              { header: "Network Status", accessor: "networkStatus" },
              { header: "Battery Status", accessor: "battery" },
              { header: "Solar Voltage", accessor: "solarVoltage" },
              { header: "Temprature", accessor: "temprature" },
              { header: "Water Meter", accessor: "waterMeter" },
              { header: "Roms Auto", accessor: "romsAuto" },
            ]}
            buttons={[]}
          />
        )}

        <div
          className=" d-flex justify-content-end align-content-center"
          style={{ marginRight: "10px", marginTop: "10px" }}
        >
          <p style={{ marginRight: "10px", marginTop: "8px" }}>
            Page {pageNumber} of {totalPages}
          </p>
          <button
            onClick={handlePrev}
            disabled={pageNumber === 1}
            className={`icon-button ${pageNumber === 1 ? "disabled" : ""}`}
          >
            <LeftIcon className="icon" />
          </button>
          <button
            className={`icon-button ${pageNumber === totalPages ? "disabled" : ""}`}
            onClick={handleNext}
            disabled={pageNumber === totalPages}
          >
            <RightIcon className="icon" />
          </button>
        </div>
      </Card>
      <Modal
        isOpen={isDeleteModalOpen}
        toggle={() => setIsDeleteModalOpen(!isDeleteModalOpen)}
      >
        <ModalHeader>Delete Distributary</ModalHeader>
        <ModalBody>
          Are you sure you want to delete this distributary?
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={() => handleDeleteOms(selectedId)}>
            Delete
          </Button>
          <Button color="secondary" onClick={() => setIsDeleteModalOpen(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};
export default OmsList;
